import { ModalContext, ModalType } from '@context/modalContext';
import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import LoadingModal from '@components/atoms/modals/LoadingModal';

const ModalWrapper = ({ children }: { children: ReactNode }) => {
    const [Modal, setModal] = useState<ModalType>(null);
    const [loading, setLoading] = useState(false);

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            setModal(null);
        }
    };

    useEffect(() => {
        if (Modal) {
            document.body.style.overflow = 'hidden';

            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [Modal]);

    return (
        <ModalContext.Provider value={{ Modal, setModal, loading, setLoading }}>
            {Modal && createPortal(Modal, document.body)}
            {loading && createPortal(<LoadingModal />, document.body)}
            {children}
        </ModalContext.Provider>
    );
};

export default ModalWrapper;
